import * as React from "react"
const CopyIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={ 18 }
    height={ 18 }
    fill="currentColor"
    viewBox="0 0 24 24"
    { ...props }
  >
    <path d="M19 21H8V7h11m0-2H8a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2m-3-4H4a2 2 0 0 0-2 2v14h2V3h12V1Z" />
  </svg>
)
export default CopyIcon
